module.exports = "/images/vendor/jquery-ui/themes/base/ui-icons_ffffff_256x240.png?47d227801c1ad6c59d033bc151848c07";